import { getReq } from '../service/API'
import useSWR from 'swr'
import { BASE_URL } from '../constants'
import { ProjectWithSites } from '../Types'
//import { errorStore } from '../store/ErrorStore'

export const useProjects = () => {
  const p = BASE_URL + `/dashboard/projects`

  //const cacheKey = formId ? p : null
  const { data, error } = useSWR(p, getReq, {
    suspense: true,
    dedupingInterval: 60 * 60 * 1000, // 60 minutes in milliseconds
    revalidateOnReconnect: false,
    revalidateOnFocus: false,
  })

  /*if (error) {
		setError(error.error)
	}*/

  return {
    data: (!data ? data : data.data) as ProjectWithSites[],
    isLoading: !error && !data,
    isError: error,
  }
}
